import { format, isValid } from 'date-fns'

export const formatDate = (dateString, dateFormat = 'dd/MM/yyyy') => {
  const date = new Date(dateString)
  return isValid(date) ? format(date, dateFormat) : dateString
}
